import React, { Fragment, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import { useAuth } from "../../../context/AuthContext";
import swal from "sweetalert";

import { functions } from "../../../firebase";

import {
  startAddReport,
  startSetReports,
  startRemoveReport,
  startEditReport,
} from "../../../actions/reports";
import { httpsCallable } from "firebase/functions";
import selectReports from "../../../selectors/reports";
import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";
import PatientReportForm from "./PatientReportForm";
import PatientReportItem from "./PatientReportItem";
import {
  canDeletePatientReport,
  canUploadPatientReport,
} from "./patientReportPermissions";
const PatientReport = ({
  profile,
  reportsList,
  startAddReport,
  startSetReports,
  startRemoveReport,
}) => {
  const getSignedUrl = httpsCallable(functions, "getSignedUrl");
  const { currentUser } = useAuth();
  const [isEdit, setIsEdit] = useState(false);
  const [reportEditData, setReportEditData] = useState(null);
  const [isLoding, setIsLoading] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [reports, setReports] = useState([]);

  const [fileUrl, setFileUrl] = useState(null);
  const canUploadReport = canUploadPatientReport(
    currentUser && currentUser.roles,
  );
  const canDeleteReport = canDeletePatientReport(
    currentUser && currentUser.roles,
  );

  const onSubmit = async (files) => {
    if (!isEdit) {
      const report = {
        hn: profile.hn,
        createBy: currentUser.displayName,
        createAt: new Date(),
      };
      setIsLoading(true);
      try {
        await startAddReport(report, files);
        await startSetReports(profile.hn);
        notifyTopRight("Report uploaded");
      } catch (error) {
        console.error("Unable to upload patient report", error);
        notifyError("Cannot upload patient report. Please try again.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsEdit(false);
    }
  };

  const onDelete = ({ hn, id }) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        startRemoveReport({ hn, id });

        swal(`Poof! Your file has been deleted!`, {
          icon: "success",
        });
      } else {
        swal("Canceled");
      }
    });
  };

  const onEdit = (data) => {
    setIsEdit(true);
    setReportEditData(data);
  };

  const onCancelEdit = () => {
    setIsEdit(false);
  };

  const onDownLoad = async (hn, id, file) => {
    try {
      const result = await getSignedUrl({
        folder: "reports",
        hn,
        id,
        filename: file,
      });
      const response = await fetch(result.data);

      if (!response.ok) {
        throw new Error(`File download failed with status ${response.status}`);
      }

      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = fileURL;
      downloadLink.download = file;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Unable to download patient report file", error);
      notifyError("Cannot download patient report file. Please try again.");
    }
  };

  const onViewFile = (hn, id, file) => {
    setFileUrl(null);
    getSignedUrl({
      folder: "reports",
      hn,
      id,
      filename: file,
    })
      .then((result) => {
        setFileUrl(result.data);
        setCreateModal(true);
      })
      .catch((error) => {
        console.error("Unable to open patient report file", error);
        notifyError("Cannot open patient report file. Please try again.");
      });
  };

  const handleOnHideModal = () => {
    setCreateModal(false);
    setFileUrl(null);
  };

  useEffect(() => {
    let isActive = true;

    const loadReports = async () => {
      setIsLoading(true);
      try {
        await startSetReports(profile.hn);
      } catch (error) {
        console.error("Unable to load patient reports", error);
        if (isActive) {
          notifyError("Cannot load patient reports. Please try again.");
        }
      } finally {
        if (isActive) setIsLoading(false);
      }
    };

    loadReports();

    return () => {
      isActive = false;
    };
  }, [profile]);

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={createModal}
        onHide={handleOnHideModal}
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>Report</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-0 p-0">
          <div
            className="card-body mx-0 p-0 col-lg-12"
            style={{ height: "85vh" }}
          >
            <iframe
              className="col-lg-12 m-0 p-0"
              src={fileUrl + "#toolbar=1"}
              title="Patient report file preview"
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <PatientReportForm
        hn={profile.hn}
        onSubmit={onSubmit}
        canUpload={canUploadReport}
      />
      <text>
      Please upload the Sleep Study Report (SS-123-report-signed) and Medical Certificate (SS-123-medical-certificate-signed)
      </text>
      {/* {!isEdit ? (
        <PatientReportForm
          onSubmit={onSubmit}
          hn={profile.hn}
          createBy={currentUser.displayName}
        />
      ) : (
        <PatientReportEditForm
          onSubmit={onSubmit}
          onCancel={onCancelEdit}
          hn={profile.hn}
          createBy={currentUser.displayName}
          note={noteEditData}
        />
      )} */}
      {!isLoding && (
        <PatientReportItem
          reports={reportsList}
          hn={profile.hn}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewFile={onViewFile}
          onDownLoad={onDownLoad}
          canDelete={canDeleteReport}
        />
      )}
    </Fragment>
  );
};

// export default PatientReport;
const mapStateToProps = (state, props) => ({
  reportsList: selectReports(state.reports),
});

const mapDispatchToProps = (dispatch) => ({
  startSetReports: (reports) => dispatch(startSetReports(reports)),
  startEditReport: (id, report, files) =>
    dispatch(startEditReport(id, report, files)),
  startRemoveReport: (data) => dispatch(startRemoveReport(data)),
  startAddReport: (report, files) => dispatch(startAddReport(report, files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientReport);
